import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Flex, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Text, Tooltip, useColorModeValue } from '@chakra-ui/react'
import { CaretRight, Dot } from '@phosphor-icons/react'
import { ArrowLeft } from '@phosphor-icons/react/dist/ssr'
import { subtract } from 'lodash'
import { Link, useLocation } from 'react-router-dom'

interface Props {
    showText: boolean
    id: number
    name: string
    icon: (args1: string) => React.ReactNode
    subItems?: SubItem[]
    url?: string
}

interface SubItem {
    name: string
    url: string
}

const ShrinkMenuItem = ({ showText, name, icon, subItems, url }: Props) => {
    const { pathname } = useLocation()
    const backgroundHoverColor = useColorModeValue('green.600', 'green.700')
    const backgroundActiveColor = useColorModeValue('white', 'gray.100')

    const isActive = (value: string): boolean => {
        return pathname.includes(value)
    }

    const isSubActive = (value?: SubItem[]): boolean => {
        if (!value) return false;
        return value.some(sub => pathname.includes(sub.url))
    }

    return (
        <Box>
            {
                url ?
                    <Tooltip label={name} placement="right" size="lg">
                        <Link to={url || ""}>
                            <Box
                                h="60px" w="full"
                                backgroundColor={isActive(url) ? backgroundActiveColor : 'transparent'}
                                _hover={{ backgroundColor: isActive(url) ? '#FFF' : backgroundHoverColor }}
                            >
                                <Flex w="full" h="full" justifyContent="center" alignItems="center">
                                    <Text color={isActive(url) ? 'green.500' : '#FFF'} >
                                        {icon(isActive(url) ? '#22543D' : '#FFF')}
                                    </Text>
                                </Flex>
                            </Box>
                        </Link>
                    </Tooltip>
                    :
                    <Menu placement="right-start">
                        <MenuButton display="flex" justifyContent="center" alignItems="center" w="full"
                            backgroundColor={isSubActive(subItems) ? backgroundActiveColor : 'transparent'}
                            _hover={{ backgroundColor: isSubActive(subItems) ? '#FFF' : backgroundHoverColor }}
                        >
                            <Box
                                mx="auto"
                                h="60px" w="full"
                                backgroundColor={isSubActive(subItems) ? backgroundActiveColor : 'transparent'}
                                _hover={{ backgroundColor: isSubActive(subItems) ? '#FFF' : backgroundHoverColor }}
                            >
                                <Flex w="full" h="full" justifyContent="center" alignItems="center" position="relative">
                                    {icon(isSubActive(subItems) ? '#22543D' : '#FFF')}
                                    <Flex position="absolute" right={1}>
                                        <CaretRight size={16} color={isSubActive(subItems) ? '#22543D' : '#FFF'} />
                                    </Flex>
                                </Flex>
                            </Box>
                        </MenuButton>
                        <MenuList backgroundColor="green.800">
                            <MenuGroup title={name} textColor="#FFF">
                                {
                                    subItems?.map((item) =>
                                        <Link to={item.url} id="BBB">
                                            <MenuItem
                                                id="AAA"
                                                color={isActive(item.url) ? 'green.500' : '#FFF'}
                                                backgroundColor={isActive(item.url) ? backgroundActiveColor : 'green.800'}
                                                _focus={{
                                                    backgroundColor: isActive(item.url) ? backgroundActiveColor : 'green.800'
                                                }}
                                                _hover={{ backgroundColor: isActive(item.url) ? backgroundActiveColor : backgroundHoverColor }}
                                                icon={<Dot size="18px" weight="bold" />}>{item.name}</MenuItem>
                                        </Link>
                                    )
                                }
                            </MenuGroup>
                        </MenuList>
                    </Menu>
            }
        </Box >
    )
}

export default ShrinkMenuItem